/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../app/constants/events';

xplenty.directive('plan', [
  '$rootScope',

  function ($rootScope) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/plan.html'),

      replace: true,

      scope: {
        plan: '=ngModel',
        subscription: '=',
      },
      link(scope, element, attrs) {
        scope.$watch('subscription', function (subscription) {
          if (subscription) {
            scope.plan.active = subscription.plan_id === scope.plan.id;
          }
        });

        scope.getAbsoluteUrl = $rootScope.getAbsoluteUrl;

        scope.updatePlan = function (plan) {
          if (plan.active) return;

          $rootScope.$broadcast(EVENTS.PLAN_CHANGED, plan);
        };
      },
    };
  },
]);
